import React from "react";
import Head from "next/head";

import PropertyDocuments from "components/PropertyDocuments";

import { useFormattedMessage } from "hooks";
import { neuprop0403 } from "i18n/messages/meta";
import { getDocumentsHost } from "common/helper";

const DOCUMENT_HOST = getDocumentsHost();

const DEK01DocumentsData = [
    {
        title: "Schuldverschreibungsbedingungen COE DE-K-01",
        path: `${DOCUMENT_HOST}/docs/general/neuprop/neuprop040-3/DE-K-01/FINEXITY_neuprop040-3_Schuldverschreibungsbedingungen.pdf`,
        description: "Stand 03/2021 - PDF - 410 KB",
    },
    {
        title: "Basisinformationsblatt (BIB)* COE DE-K-01",
        path: `${DOCUMENT_HOST}/docs/general/neuprop/neuprop040-3/DE-K-01/FINEXITY_neuprop040-3_Basisinformationsblatt.pdf`,
        description: "Stand 03/2021 - PDF - 214 KB",
    },
    {
        title: "Basisinformationsblatt (BIB)* COE DE-K-01",
        path: `${DOCUMENT_HOST}/docs/general/neuprop/neuprop040-3/DE-K-01/neuprop040-3_DE-K-01_Basisinformationsblatt_2023.pdf`,
        description: "Stand 01/2023 - PDF - 214 KB",
    },
];

const Neuprop0403 = () => {
    const { formatMessage } = useFormattedMessage();

    return (
        <>
            <Head>
                <title>{formatMessage(neuprop0403.title)}</title>
                <meta name="description" content="neuprop 040 - 3 GmbH & Co. KG" />
            </Head>
            <div className="broad-container issuer-public-page">
                <section className="banner-section" style={{ backgroundImage: "url(/images/neupropBg.jpg)" }} />
                <section className="content-section small-container">
                    <div className="header-part">
                        <div className="logo-container shadow border-radius">
                            <img src={"/images/logo-neuprop-3.png"} alt="" />
                        </div>
                        <p>
                            Der Unternehmensgegenstand der Gesellschaft besteht in dem Erwerb, dem Halten und Verwalten von
                            Grundstücken (die "Immobilie(n)").
                        </p>
                    </div>
                    <div className="border-x" />
                    <div className="content-part">
                        <h2>neuprop 040 - 3 GmbH & Co. KG</h2>
                        <p>
                            Bei der Finanzierung verfolgt die neuprop 040 - 3 GmbH & Co. KG eine langfristig ausgerichtete
                            Strategie.
                        </p>
                    </div>
                    <div className="two-parts">
                        <div className="first-part">
                            <div className="pdf-part">
                                <h3>Kapitalmarktdokumentation</h3>
                                <PropertyDocuments showTextLength={55} propertyDocumentsData={DEK01DocumentsData} />
                                <span className="bottom-line text-14 d-block">
                                    *Basisinformationsblatt gemäß EU-Verordnung 1286/2014
                                </span>
                            </div>
                        </div>
                        <div className="second-part ml-0">
                            <h3>Kontakt</h3>
                            <p>
                                Bei Fragen zu den tokenisierten Schuldverschreibungen sind wir persönlich erreichbar über die
                                E-Mail-Adresse:
                                <br />
                                <a href="mailto:neuprop040-3@finexity.com">neuprop040-3@finexity.com</a>
                            </p>
                        </div>
                    </div>
                </section>
            </div>
        </>
    );
};

export default Neuprop0403;
